import SectionLabel from '../components/SectionLabel'
import { WA_DISPLAY } from '../constants'

// Simple text block helper matching the site's typography.
function P({ children }) {
  return (
    <p style={{ fontSize: '15px', color: 'var(--ink-mid)', lineHeight: 1.8, fontWeight: 300, marginBottom: '20px' }}>
      {children}
    </p>
  )
}

function H({ children }) {
  return (
    <h2 style={{ fontSize: '22px', fontWeight: 600, fontFamily: 'var(--serif)', margin: '40px 0 16px' }}>
      {children}
    </h2>
  )
}

export default function PrivacyPolicy() {
  const CONTACT_EMAIL = 'ktmtravelguide@gmail.com'

  return (
    <main style={{ background: 'var(--white)' }}>
      <section style={{ background: 'var(--green-dark)', padding: '100px 5% 60px', color: 'white', textAlign: 'center' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <SectionLabel>Legal</SectionLabel>
          <h1 className="serif" style={{ fontSize: 'clamp(32px, 6vw, 48px)', fontWeight: 600, color: 'white' }}>
            Privacy Policy
          </h1>
        </div>
      </section>

      <section className="section" style={{ maxWidth: '760px', margin: '0 auto' }}>
        <P>
          This page explains what information we collect when you visit KTM Travel Guide, why we collect
          it, and the choices you have. We've tried to keep it plain and honest — no legalese.
        </P>

        <H>Who we are</H>
        <P>
          KTM Travel Guide is an independent, licensed trekking guide based in Kathmandu, Nepal. This
          website is a simple showcase of our treks; there are no user accounts, no shopping cart, and no
          payments taken on the site. Bookings and enquiries happen over WhatsApp.
        </P>

        <H>What we collect</H>
        <P>
          We do not ask you for any personal information on this website — there are no sign-up or contact
          forms that store your data. The only data collected is anonymous, aggregated usage information
          gathered automatically by third-party analytics and advertising tools:
        </P>
        <ul style={{ fontSize: '15px', color: 'var(--ink-mid)', lineHeight: 1.9, fontWeight: 300, marginBottom: '20px', paddingLeft: '20px' }}>
          <li>
            <strong>Google Analytics 4</strong> — sets cookies to measure page views, which pages are
            popular, roughly where visitors come from (country/region), and what device and browser they
            use. This helps us understand which treks people are interested in.
          </li>
          <li>
            <strong>Meta Pixel (Facebook/Instagram)</strong> — sets cookies that record that you visited
            this site, so that if we run ads on Facebook or Instagram we can measure whether they work and
            show relevant ads. It tracks page views only.
          </li>
        </ul>

        <H>Cookies</H>
        <P>
          Both tools above use cookies — small text files stored in your browser. They are used for
          analytics and advertising measurement, not to identify you personally to us. You can block or
          delete cookies at any time in your browser settings, and you can opt out of Google Analytics
          using Google's browser add-on. Blocking these cookies will not affect your ability to use the
          site or contact us.
        </P>

        <H>How we use the information</H>
        <P>
          We use this anonymous data only to understand how the site is performing and to improve it, and
          to measure and target advertising on Meta platforms. We do not sell your data, and we do not
          combine it with any personal details (because we don't collect any here).
        </P>

        <H>Contacting us by WhatsApp</H>
        <P>
          When you click a "WhatsApp" button on this site, you are taken to WhatsApp to start a
          conversation with us. Anything you choose to share in that chat (your name, dates, questions) is
          handled inside WhatsApp under WhatsApp's own privacy terms, and by us directly to answer you and
          arrange your trek. We only keep what we need to respond to your enquiry.
        </P>

        <H>Your rights (EU / UK visitors)</H>
        <P>
          If you are in the EU, UK, or a similar region (for example the Netherlands, Germany, or the
          United Kingdom), you have the right to access, correct, or ask us to delete any personal data we
          hold about you, and to object to analytics or advertising cookies. Since this website only
          collects anonymous analytics data, most requests will relate to any WhatsApp conversation you've
          had with us. Contact us and we'll help.
        </P>

        <H>Contact</H>
        <P>
          Questions about this policy or your data? Email us at{' '}
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: 'var(--green)', fontWeight: 500 }}>{CONTACT_EMAIL}</a>{' '}
          or message us on WhatsApp at <strong>{WA_DISPLAY}</strong>.
        </P>

        <P>
          This policy may be updated from time to time. Any changes will be posted on this page.
        </P>
      </section>
    </main>
  )
}
